import React, { Component, PropTypes } from 'react'

import Close from '../Close'
import styles from './index.css'
import headerImg from './barner.png'
import config from 'config'
import qs from 'querystring'

class Consult extends Component {
  constructor (props) {
    super(props)
    this.state = {
      question: '',
      phone: '',
      messageCode: '',     // 短信验证码
      imageCode: '',
      count: 60,
      errorInfo: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.sendVerifyCode = this.sendVerifyCode.bind(this)
    this.toggleImage = this.toggleImage.bind(this)
    this.countdown = this.countdown.bind(this)
  }

  toggleImage (e) {
    const src = e.target.src
    e.target.src = `${src}?6666=${e.timeStamp}`
  }

  sendVerifyCode () {
    const { phone, imageCode, count } = this.state
    if (count !== 60) {
      return
    }
    if (!/1[3|5|7|8|][0-9]{9}/.test(phone)) {
      this.setState({
        errorInfo: '请输入合法手机号码'
      })
      return
    }
    this.setState({ errorInfo: '' })
    fetch(`${config.userService.url}/captcha/phone/jsonp?phone=${phone}&captcha=${imageCode}&smartCallback=0&type=authenticode`, {
      credentials: 'include'
    })
    .then(res => res.text())
    .then(data => {
      const json = JSON.parse(data.slice(2, -1))
      if (json.msg) {
        throw new Error(json.msg)
      }
      this.countdown()
    })
    .catch(err => {
      this.setState({
        errorInfo: err.message
      })
    })
  }

  countdown () {
    setTimeout(() => {
      this.setState(({ count: prevcount }) => {
        if (prevcount === 0) {
          return { count: 60 }
        }
        return { count: prevcount - 1 }
      })
      if (this.state.count !== 60 ) {
        this.countdown()
      }
    }, 1000)
  }

  handleSubmit (e) {
    const {
      question,
      phone,
      messageCode
    } = this.state
    if (!question) {
      this.setState({ errorInfo: '请填写问题' })
      return
    }
    if (!phone) {
      this.setState({ errorInfo: '请输入手机号码' })
      return
    }
    fetch(`${config.userService.url}/captcha/phone/check?phone=${phone}&captchaPhone=${messageCode}`, {
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      if (data.code !== 0) {
        throw new Error(data.msg)
      }
      if (!data.data) {
        throw new Error('手机验证码错误')
      }
      return fetch(`${config.api.promotion}/user`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: qs.stringify({
          phone,
          name: '',
          source: '',
          pageName: 'consult',
          index: 0,
          type: 1,
          repeat: 1,
          extension: JSON.stringify({question : question})
        })
      })
    })
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) {
        throw new Error(json.msg)
      }else {
        this.setState({
          errorInfo: '咨询成功'
        },()=> {
          setTimeout(()=>{
            this.props.onClose()
          },1000)
        })
      }
    })
    .catch(err => {
      this.setState({
        errorInfo: err.message
      })
    })
  }

  renderExample () {
    return (
      <div className={styles.example}>
        <div className={styles.title}>
          问题示例
        </div>
        <div className={styles.desc}>
          <div className={styles.avator1}></div>
          <div className={styles.text}>这道写作题主要应该从哪几个论点入手</div>
        </div>
        <div className={styles.desc}>
          <div className={styles.avator2}></div>
          <div className={styles.text}>这里可以有三个分论点哦，一个是It was used to move commodities and people...</div>
        </div>
      </div>
    )
  }

  renderForm () {
    const { phone, question, messageCode, imageCode, count, errorInfo } = this.state

    return (
      <div className={styles.form}>
        <div className="area">
          <textarea
            rows="10"
            placeholder="你对这道题的问题是什么"
            value={question}
            onChange={e => this.setState({ question: e.target.value })}
          />
        </div>
        <div className="text">
          为了方便辅导教师联系你，请留下你的联系方式。
        </div>
        <div className="phone">
          <span className={styles.phoneicon}></span>
          <input
            type="text"
            placeholder="请输入手机号码"
            value={phone}
            onChange={e => this.setState({ phone: e.target.value })}
          />
        </div>
        <div className="row code">
          <span className={styles.codeicon}></span>
          <input
            type="text"
            placeholder="请输入图形验证码"
            value={imageCode}
            onChange={e => this.setState({ imageCode: e.target.value })}
          />
          <img
            src={`${config.userService.url}/captcha`}
            alt="code"
            onClick={this.toggleImage}
          />
        </div>
        <div className="verify-code">
          <span className={styles.codeicon}></span>
          <input
            type="text"
            placeholder="请输入短信验证码"
            value={messageCode}
            onChange={e => this.setState({ messageCode: e.target.value })}
          />
          <span
            style={count === 60 ? {} : { backgroundColor: '#aaa' }}
            className={styles.button}
            onClick={this.sendVerifyCode}
          >
            { count === 60 ? '发送验证码' : `${count}秒后重发` }
          </span>
        </div>
        <div className="error">{ errorInfo }</div>
        <span className={styles.button} onClick={this.handleSubmit}>提交</span>
      </div>
    )
  }

  render () {
    const { show, onClose } = this.props

    return show && (
      <div
        className={styles.root}
        onClick={e => {
          if (e.target === e.currentTarget) {
            onClose()
          }
        }}
      >
        <div className={styles.modal}>
          <Close onChange={onClose}></Close>
          <div className={styles.header}>
            <img src={headerImg} alt="header" width="100%" />
          </div>
          <div className={styles.body}>
            { this.renderExample() }
            { this.renderForm() }
          </div>
        </div>
      </div>
    )
  }
}


Consult.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default Consult



/** WEBPACK FOOTER **
 ** ./src/components/Common/Consult/index.js
 **/